import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_GYyamkZWiQB4: {
	id: 'prd_GYyam2DEV2kZWiQB4'
	ident: 'prd_GYyamkZWiQB4'
	sku: 'simple_premium_1w_3_53_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_8H6HK2DEV2LryRxQP'
			amount: 22
			amount_usd: 3.53
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 3.53
			discount: 18.47
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_bH1mr2DEV2pvhK0NG'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_GYyamkZWiQB4, SubscriptionProduct>
const prd_GYyamkZWiQB4 = { ident: 'prd_GYyamkZWiQB4' } as typeof _prd_GYyamkZWiQB4

export default prd_GYyamkZWiQB4
